// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__9nxzP","cover":"App_cover__1Jjh_","image":"App_image__1zxmb","button":"App_button__2sWSH","websiteTitle":"App_websiteTitle__c5CRp"};